import React from "react";

export default function ReceiptPreview({ text }) {
  return (
    <div
      style={{
        display: "inline-block",
        background: "#f9f9f9", // light gray like receipt paper
        border: "1px solid #ddd",
        padding: "15px 10px",
        width: "350px", // ~32 chars width
        fontFamily: "monospace",
        whiteSpace: "pre-wrap",
        lineHeight: "1.4em",
        borderRadius: "12px",
        boxShadow: "rgb(15 14 14 / 50%) 5px 5px 5px 5px",
        position: "relative",
        marginTop: "60px",
      }}
    >
      {/* Top roll effect */}
      <div
        style={{
          content: '""',
          position: "absolute",
          top: "-8px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "70%",
          height: "10px",
          background: "#f9f9f9",
          border: "1px solid #ddd",
          borderBottom: "none",
          borderRadius: "20px 20px 0 0",
          
        }}
      />
      {/* Receipt text */}
      {text}
      {/* Bottom roll effect */}
      <div
        style={{
          content: '""',
          position: "absolute",
          bottom: "-8px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "70%",
          height: "10px",
          background: "#f9f9f9",
          border: "1px solid #ddd",
          borderTop: "none",
          borderRadius: "0 0 20px 20px",
        }}
      />
    </div>
  );
}
